import React from 'react'

interface PartnerLayoutProps {
  children: React.ReactNode
}

export const PartnerLayout: React.FC<PartnerLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen w-full">
      <div className="mx-auto px-2 py-4">
        {/* Main content area */}
        <div className="space-y-6">
          {children}
        </div>
      </div>
    </div>
  )
}
